export default class TariffCapacity {
    TariffId: number = 0;
    Date: string = '';
    ZoneId?: string;
    Capacity: number = 0;
    Count: number = 0;
    SeanceId: string = '';
    ReservedCount: number = 0;

    get LeftCount(): number {
        let result = (this.Capacity - this.Count) - this.ReservedCount;
        return result < 0 ? 0 : result;
    }
}